import { useContext, useEffect, useRef, useState } from "react";
import Select2 from "../select2/Select2";
import { AllEquipments, AllRoom, ShowEquipment } from "../../api/api";
import { Context } from "../../context/Context";
import ErrorToast from "../toasts/ErrorToast";
const SelectEquipmentModal = ({
  closeSelectEquipmentRef,
  mode,
  handleSelectOutputEquipmentModal: handleSelectScheduleOutputEquipmentModal,
}) => {
  const {
    setSelectEquipmentModal,
    handleSelectOutputEquipmentModal,
    authUser,
    rooms,
    setRooms,
    setScenarioMode,
    setScenarioEquipmentType,
    setScenarioEquipmentId,
    scheduleEquipmentType,
    setScheduleEquipmentType,
    scheduleEquipmentId,
    setScheduleEquipmentId,
    setIsLoading,
    equipments,
  } = useContext(Context);
  const modalName = useRef(null);
  const [roomsOptions, setRoomsOptions] = useState([]);
  const [roomEquipments, setRoomEquipments] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState();

  const equipmentsRef = useRef();

  // useEffect(() => {
  //   setIsLoading(true);
  //   AllRoom({
  //     user_id: authUser.id,
  //   })
  //     .then(({ data }) => {
  //       setRooms(
  //         data.rooms.map((room) => ({
  //           id: room.id,
  //           name: room.name,
  //         }))
  //       );
  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error("Failed to fetch rooms:", err); // Improved error handling
  //       // Optionally, set an error state here to display an error message to the user
  //     });
  // }, [rooms]);

  useEffect(() => {
    setSelectEquipmentModal(modalName);
    setRoomsOptions([]);
    rooms.map((room) => {
      setRoomsOptions((roomsList) => [
        ...roomsList,
        {
          name: room.name,
          value: room.id,
        },
      ]);
    });
    equipmentsRef.current = equipments;
  }, [rooms, equipments]);

  const handleChangeRoomSelect = (roomId) => {
    // setIsLoading(true);
    if (roomId) {
      // AllEquipments({
      //   room_id: roomId,
      // })
      //   .then(({ data }) => {
      //     setRoomEquipments([]);
      //     setRoomEquipments(
      //       data.equipments.map((equip) => ({
      //         value: equip.equipment_id,
      //         name: equip.equipment.name,
      //       }))
      //     );
      //     setIsLoading(false);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      setRoomEquipments([]);
      let eqs = equipmentsRef.current.filter((eq) => eq.room_id == roomId);
      setRoomEquipments(
        eqs.map((eq) => ({
          value: eq.equipment_id,
          name: eq.equipment.name,
        })),
      );
    }
  };

  const handleSelectEquipment = (equipment_id) => {
    setSelectedEquipment(equipment_id);
  };

  const handleSubmitSelectedEquipment = () => {
    // setIsLoading(true);
    // ShowEquipment({
    //   equipment_id: selectedEquipment,
    // }).then(({ data }) => {
    //   if (mode == "scenario") {
    //     setScenarioMode(true);
    //     setScenarioEquipmentType(data.equipment.type);
    //     setScenarioEquipmentId(selectedEquipment);
    //     handleSelectOutputEquipmentModal(true);
    //   } else if (mode == "schedule") {
    //     setScheduleEquipmentType(data.equipment.type);
    //     setScheduleEquipmentId(data.equipment.id);
    //     handleSelectScheduleOutputEquipmentModal(true);
    //   }
    //   setIsLoading(false);
    // });

    let equipment = equipments.find((eq) => eq.id == selectedEquipment);
    if (!equipment) {
      return ErrorToast("تجهیزی انتخاب نشده است");
    }
    if (mode == "scenario") {
      setScenarioMode(true);
      setScenarioEquipmentType(equipment.equipment.type);
      setScenarioEquipmentId(selectedEquipment);
      handleSelectOutputEquipmentModal(true);
    } else if (mode == "schedule") {
      setScheduleEquipmentType(equipment.equipment.type);
      setScheduleEquipmentId(equipment.equipment_id);
      handleSelectScheduleOutputEquipmentModal(true);
    }
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="selectEquipmentModal"
      tabIndex="-1"
      aria-labelledby="SelectEquipmentLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="SelectEquipmentLable">
              انتخاب تجهیز
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeSelectEquipmentRef}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-12 mb-4">
                <Select2
                  parentElem={"#selectEquipmentModal"}
                  options={roomsOptions}
                  setValue={handleChangeRoomSelect}
                />
              </div>
              <div className="col-12 mb-4">
                <Select2
                  parentElem={"#selectEquipmentModal"}
                  options={roomEquipments}
                  setValue={handleSelectEquipment}
                />
              </div>
              <div className="col-12">
                {/* <button
                  type="button"
                  className="btn btn-success-app mb-2"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  انصراف
                </button> */}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-2 mb-2"
              onClick={(status) => handleSubmitSelectedEquipment()}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectEquipmentModal;
